import { type LoginInput, type LoginMutation } from '@exam-room/graphql';

interface UserProfile {
  firstname: string;
  lastname: string;
  displayName: string;
  username: string;
  email?: string | null;
  avatarImageUrl?: string | null;
  idNumber?: string | null;
}

enum AuthState {
  LOADING = 'LOADING',
  LOGGED_IN = 'LOGGED_IN',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
}

type AuthAction =
  | { type: 'SET_LOADING' }
  | { type: 'SET_LOGGED_IN'; payload: UserProfile }
  | { type: 'SET_NOT_LOGGED_IN' };

interface AuthStateShape {
  authState: AuthState;
  user: UserProfile | null;
}

interface Auth {
  logout: () => Promise<void>;
  isLoading: boolean;
  login: (input: LoginInput) => Promise<LoginMutation['erLogin'] | undefined>;
  authState: `${AuthState}`;
  user: UserProfile | null;
}

export { AuthState, AuthAction, AuthStateShape, Auth, UserProfile };
